import { filterObjectValues } from 'helpers/filter'

import { Mkassa } from 'models/mkassa'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api from '../api'
import { GetMkassaListResponse, GetMkassaParams } from './types'

export const mkassaApi = api.injectEndpoints({
  endpoints: build => ({
    getMkassaById: build.query<Mkassa, Mkassa['id']>({
      query: id => ({
        url: `/web/mkassa/${id}/`,
      }),
    }),
    getMkassa: build.query<GetMkassaListResponse, GetMkassaParams>({
      query: params => ({
        url: `/web/mkassa/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    getMkassaExcel: build.query<void, GetMkassaParams>({
      query: params => ({
        url: `/web/mkassa/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
    statistics: build.query<Array<IStatistic>, GetMkassaParams>({
      query: params => ({
        url: `/web/mkassa/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
  }),
})
